import React from "react";
import { useSelector } from "react-redux";
import { StyledButton } from "../../../common/components/Button/styles";
import { fabricateSet, shipSet } from "../../../api/caseApi";
import ConfirmationDialog from "../../../common/components/Dialog";
import CopyLinkButton from "./GeneratePaymentLinkDialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import isCaseTerminated from "../../../common/helpers/isCaseTerminated";
import { ButtonBase } from "@mui/material";
import { faComment } from "@fortawesome/free-solid-svg-icons";
const SetActionButtons = ({
  setsInfo,
  allSets,
  getSetsInfo,
  handleSetCurrentCaseProgress,
  handleOpenPayCaseProgress,
  handleSetCurrentProgressAmount,
  onEmailOpen,
  modeOfPayment,
  isSubscription,
  handleSetPaymentLink,
  handleOpenGeneratePaymentLink,
  caseDetails,
  handleSetOpenUpdateFabricationDate,
  handleSetOpenUpdateShipmentDate,
  handleSetOpenUpdateFabricationDateFromFabricateSet,
  handleSetOpenUpdateShipmentDateFromShipSet,
  handleOpenCommentSection,
}) => {
  const user = useSelector((state) => state.user);
  const isOperations = user.roles.includes("Operations");

  const firstSet = allSets.reduce(
    (prev, curr) => (prev.index < curr.index ? prev : curr),
    Infinity
  );
  const isFirstSet = setsInfo.id === firstSet.id;

  const renderActionButton = () => {
    if (
      !isCaseTerminated(caseDetails) &&
      modeOfPayment?.toLowerCase() === "paypal" &&
      isFirstSet &&
      isSubscription &&
      setsInfo.isPaymentRequired === true &&
      setsInfo.isPaid === false &&
      setsInfo.isDone === false
    ) {
      return (
        // send paypal subscription email
        <>
          <StyledButton
            marginRight={"4px"}
            theme="green"
            onClick={(e) => {
              e.stopPropagation();
              handleSetCurrentCaseProgress(setsInfo);
              handleSetCurrentProgressAmount(setsInfo.amountDue);
              handleSetPaymentLink(setsInfo.paymentLink);
              onEmailOpen();
            }}
            sx={{
              minWidth: "110px",
            }}
          >
            Send Email
          </StyledButton>
          <StyledButton
            onClick={() => {
              handleOpenGeneratePaymentLink();
              handleSetCurrentCaseProgress(setsInfo);
              handleSetPaymentLink(setsInfo.paymentLink);
            }}
            theme="green"
          >
            <FontAwesomeIcon icon={faLink} style={{ paddingRight: "3px" }} />
          </StyledButton>
        </>
      );
    } else if (
      !isCaseTerminated(caseDetails) &&
      modeOfPayment?.toLowerCase() === "xendit" &&
      isFirstSet &&
      isSubscription &&
      setsInfo.isPaymentRequired === true &&
      setsInfo.isPaid === false &&
      setsInfo.isDone === false
    ) {
      return (
        // send paypal subscription email
        <>
          <StyledButton
            marginRight={"4px"}
            theme="green"
            onClick={(e) => {
              e.stopPropagation();
              handleSetCurrentCaseProgress(setsInfo);
              handleSetCurrentProgressAmount(setsInfo.amountDue);
              handleSetPaymentLink(setsInfo.paymentLink);
              onEmailOpen();
            }}
            sx={{
              minWidth: "110px",
            }}
          >
            Send Email
          </StyledButton>
          <ButtonBase
            sx={{
              borderRadius: "80px",
              width: "35px",
              height: "35px",
              backgroundColor: "#161616",
              color: "white",
              padding: "10px",
              marginRight: "4px",
            }}
            onClick={() => {
              handleOpenGeneratePaymentLink();
              handleSetCurrentCaseProgress(setsInfo);
              handleSetPaymentLink(setsInfo.paymentLink);
            }}
          >
            <FontAwesomeIcon icon={faLink} />
          </ButtonBase>
        </>
      );
    } else if (
      !isCaseTerminated(caseDetails) &&
      modeOfPayment?.toLowerCase() === "xendit" &&
      isFirstSet &&
      isSubscription &&
      setsInfo.isPaymentRequired === true &&
      setsInfo.isPaid === false &&
      setsInfo.isDone === false
    ) {
      return (
        // send paypal subscription email
        <>
          <StyledButton
            marginRight={"4px"}
            theme="green"
            onClick={(e) => {
              e.stopPropagation();
              handleSetCurrentCaseProgress(setsInfo);
              handleSetCurrentProgressAmount(setsInfo.amountDue);
              handleSetPaymentLink(setsInfo.paymentLink);
              onEmailOpen();
            }}
            sx={{
              minWidth: "110px",
            }}
          >
            Send Email
          </StyledButton>
          <ButtonBase
            sx={{
              borderRadius: "80px",
              width: "35px",
              height: "35px",
              backgroundColor: "#161616",
              color: "white",
              padding: "10px",
              marginRight: "4px",
            }}
            onClick={() => {
              handleOpenGeneratePaymentLink();
              handleSetCurrentCaseProgress(setsInfo);
              handleSetPaymentLink(setsInfo.paymentLink);
            }}
          >
            <FontAwesomeIcon icon={faLink} />
          </ButtonBase>
        </>
      );
    } else if (
      !isCaseTerminated(caseDetails) &&
      setsInfo.isPaymentRequired === true &&
      setsInfo.isPaid === false &&
      setsInfo.isDone === false &&
      !isFirstSet &&
      isSubscription
    ) {
      // paypal and xendit automatic payment
      return null;
    } else if (
      !isCaseTerminated(caseDetails) &&
      modeOfPayment?.toLowerCase() === "gcash" &&
      isSubscription &&
      setsInfo.isPaid === false &&
      setsInfo.isDone === false
    ) {
      // send gcash email
      return (
        <>
          <StyledButton
            marginRight={"4px"}
            theme="green"
            onClick={(e) => {
              e.stopPropagation();
              handleSetCurrentCaseProgress(setsInfo);
              handleSetCurrentProgressAmount(setsInfo.amountDue);
              handleSetPaymentLink(setsInfo.paymentLink);
              onEmailOpen();
            }}
            sx={{
              minWidth: "110px",
            }}
          >
            Send Email
          </StyledButton>
          <ButtonBase
            sx={{
              borderRadius: "80px",
              width: "35px",
              height: "35px",
              backgroundColor: "#161616",
              color: "white",
              padding: "10px",
              marginRight: "4px",
            }}
            onClick={() => {
              handleOpenGeneratePaymentLink();
              handleSetCurrentCaseProgress(setsInfo);
              handleSetPaymentLink(setsInfo.paymentLink);
            }}
          >
            <FontAwesomeIcon icon={faLink} />
          </ButtonBase>
        </>
      );
    } else if (
      !isCaseTerminated(caseDetails) &&
      setsInfo.isPaymentRequired === true &&
      setsInfo.isPaid === false &&
      setsInfo.isDone === false &&
      !isSubscription
    ) {
      // manual payment
      return (
        <>
          <StyledButton
            marginRight={"4px"}
            onClick={(e) => {
              e.stopPropagation();
              handleSetCurrentCaseProgress(setsInfo);
              handleSetCurrentProgressAmount(setsInfo.amountDue);
              handleSetPaymentLink(setsInfo.paymentLink);
              console.log(setsInfo.id);
              handleOpenPayCaseProgress();
            }}
            theme="green"
            sx={{
              minWidth: "110px",
            }}
          >
            Pay
          </StyledButton>
          <ButtonBase
            onClick={() => {
              handleOpenGeneratePaymentLink();
              handleSetCurrentCaseProgress(setsInfo);
              handleSetPaymentLink(setsInfo.paymentLink);
            }}
            sx={{
              borderRadius: "80px",
              width: "35px",
              height: "35px",
              backgroundColor: "#161616",
              color: "white",
              padding: "10px",
              marginRight: "4px",
            }}
          >
            <FontAwesomeIcon icon={faLink} />
          </ButtonBase>
        </>
      );
    } else if (
      !isCaseTerminated(caseDetails) &&
      isOperations &&
      setsInfo.setNameForFabrication &&
      setsInfo.isFabricated === false &&
      setsInfo.isDone === false
    ) {
      return (
        <StyledButton
          marginRight={"4px"}
          onClick={(e) => {
            e.stopPropagation();
            handleSetCurrentCaseProgress(setsInfo);
            handleSetOpenUpdateFabricationDateFromFabricateSet();
            handleSetOpenUpdateFabricationDate();
          }}
          theme="green"
          sx={{
            minWidth: "110px",
          }}
        >
          Fabricate set
        </StyledButton>
      );
    } else if (
      !isCaseTerminated(caseDetails) &&
      isOperations &&
      ((setsInfo.setNameForFabrication && setsInfo.isFabricated === true) ||
        !setsInfo.setNameForFabrication) &&
      setsInfo.isShipped === false &&
      setsInfo.isDone === false
    ) {
      return (
        <StyledButton
          marginRight={"4px"}
          onClick={(e) => {
            e.stopPropagation();
            handleSetCurrentCaseProgress(setsInfo);
            handleSetOpenUpdateShipmentDateFromShipSet();
            handleSetOpenUpdateShipmentDate();
          }}
          theme="green"
          sx={{
            minWidth: "110px",
          }}
        >
          Ship set
        </StyledButton>
      );
    } else {
      return null;
    }
  };

  return (
    <div>
      {renderActionButton()}
      {setsInfo != null && setsInfo?.caseProgressAppointments?.length > 0 && (
        <ButtonBase
          sx={{
            borderRadius: "80px",
            width: "35px",
            height: "35px",
            backgroundColor: "#161616",
            color: "white",
            padding: "10px",
          }}
          onClick={() => {
            handleSetCurrentCaseProgress(setsInfo);
            handleOpenCommentSection();
          }}
        >
          <FontAwesomeIcon icon={faComment} />
        </ButtonBase>
      )}
      <ConfirmationDialog getSetsInfo={getSetsInfo} />
    </div>
  );
};

export default SetActionButtons;
